export const parseDateInSeconds = (date = '') => {
    const array = date.split('.')

    return Date.parse(`${array[2]}-${array[1]}-${array[0]}T00:00:00`) / 1000
}